import script from "./check.vue?vue&type=script&setup=true&lang=js"
export * from "./check.vue?vue&type=script&setup=true&lang=js"

import "./check.vue?vue&type=style&index=0&id=11f147bc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\dslx464\\Desktop\\workspace\\chatgpt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11f147bc"]])

export default __exports__